import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button, SubmitButton } from "@/components/Interface/Button/Button";
import { ConfirmationButtonFlexBox } from "@/components/Layout/ConfirmationButtonGroup/ConfirmationButtonGroup";
import {
  TwoFactorAppOption,
  TwoFactorStandardOption,
} from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSetupForm";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

type AuthenticatorSetupMethodsForm = {
  type: keyof typeof ChangeTwoFactorAuthenticationMethod | null;
};

export const TwoFactorSmsAlternatives = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AuthenticatorSetupMethodsForm>();

  const onSubmit = (data: AuthenticatorSetupMethodsForm) => {
    if (data.type === ChangeTwoFactorAuthenticationMethod.APP) {
      // Handle SMS setup
      navigate(portalRoutes.user.security.setup2faApp);
    }
    if (data.type === ChangeTwoFactorAuthenticationMethod.STANDARD) {
      navigate(portalRoutes.user.security.confirmStandard);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <h3>{t("portal:user-account.security.2fa.changeOption")}</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-8">
          <TwoFactorAppOption register={register} errors={errors} />

          <TwoFactorStandardOption register={register} errors={errors} />

          <ConfirmationButtonFlexBox forceButtonWidth>
            <Button
              type="button"
              className="inverted accent"
              onClick={() => navigate(portalRoutes.user.security.base)}
            >
              {t("portal:common.buttons.back")}
            </Button>
            <SubmitButton
              className="accent"
              label={t("translation:2fa.next")}
            />
          </ConfirmationButtonFlexBox>
        </div>
      </form>
    </div>
  );
};
